import React, { useState } from 'react'
import ConfettiExplosion from 'react-confetti-explosion';

const Spark = () => {
    const [isExploding, setIsExploding] = useState(true);
    return <>{isExploding && 
    <div className='position-relative'>
    <ConfettiExplosion particleCount={300} force={1} width={2500} />
    <div className='position-absolute d-flex justify-content-center align-items-center' style={{backgroundColor: "transparent", height: '100vh', width: '100vw'}}>
       <h1>🎉 SUBSCRIBED SUCCESSFULLY</h1>
    </div>
    </div>
    }
    </>;
}

export default Spark